module.exports = __webpack_public_path__ + "img/soft-grove-kitchen-4.8a65a3c3.jpeg";